import * as React from 'react';
import { I18n } from 'react-redux-i18n-lite';
import { PropTypes } from 'prop-types';
import CustomDonutChart from '../../../common/CustomDonutChart';
import GroupAssignedTile from '../../../common/GroupAssignedTile';
import CustomIcon from '../../../common/CustomIcon';
import { ROLE, GRADEBOOK_SCOPE } from '../../../../const';
import Media from 'react-media';
import { MOBILE_MEDIA_QUERY } from '../../../../utils/mobileUtils';
import GradebookHelpButton from '../../mobile/GradebookHelpButton';

export class GradebookTopBar extends React.Component {
  static propTypes = {
    selectedBook: PropTypes.object,
    selectedUnit: PropTypes.object,
    selectedLesson: PropTypes.object,
    grades: PropTypes.object
  };

  constructor(props) {
    super(props);
  }

  loadChartData = () => {
    const { grades, selectedLesson, gradebookScope } = this.props;

    const output = {
      completed: 0,
      success: 0,
      failed: 0,
      pending: 0,
      initialized: 0,
      uncompleted: 0,
      total: 0,
      gradeIcons: []
    };

    grades.students.forEach(student => {
      student.activities.forEach(grade => {
        if (grade.complete && grade.initialized && !grade.pending) {
          let score = grade.score;
          if (score !== null) {
            if (grade.success) {
              output.success += 1;
            } else {
              output.failed += 1;
            }
            output.completed += 1;
          }
          output.total += 1;
        } else if (grade.pending && selectedLesson) {
          output.pending += 1;
          output.total += 1;
        } else if (grade.initialized) {
          output.initialized += 1;
          output.total += 1;
        } else if (!grade.complete) {
          output.uncompleted += 1;
          output.total += 1;
        }
      });
    });

    switch (gradebookScope) {
      case GRADEBOOK_SCOPE.ACTIVITIES:
        output.success = grades.passStats;
        output.failed = grades.failedStats;
        output.pending = grades.pendingStats;
        output.initialized = 0;
        output.uncompleted = 100 - grades.failedStats - grades.passStats - grades.pendingStats;
        break;
      case GRADEBOOK_SCOPE.UNIT_LESSONS:
        output.success = output.total ? (output.success * 100) / output.total : 0;
        output.failed = output.total ? (output.failed * 100) / output.total : 0;
        output.pending = output.total ? (output.pending * 100) / output.total : 0;
        output.initialized = output.total ? (output.initialized * 100) / output.total : 0;
        output.uncompleted = output.total ? (output.uncompleted * 100) / output.total : 100;
        break;
      default:
        output.success = 0;
        output.failed = 0;
        output.pending = 0;
        output.initialized = 0;
        output.uncompleted = 0;
    }

    return output;
  };

  renderPercentCircle = () => {
    const { success, failed, pending, initialized, uncompleted } = this.loadChartData();

    return (
      <CustomDonutChart
        success={success}
        failed={failed}
        pending={pending}
        initialized={initialized}
        uncompleted={uncompleted}
        label={I18n.t('gradebook.completed')}
        diameter={115}
        percentClassName={'donutchart-percent'}
        containerClassName={'gradebook-main-donutchart'}
        showTooltips={true}
      />
    );
  };

  getItemName = item => {
    if (item && item.name) {
      return typeof item.name === 'object' ? Object.values(item.name)[0] : item.name;
    }
    return null;
  };

  getTitle = () => {
    const { selectedBook, selectedUnit, selectedLesson } = this.props;
    let title = selectedBook ? this.getItemName(selectedBook) : null;
    if (selectedUnit) {
      title = this.getItemName(selectedUnit);
    }
    if (selectedLesson) {
      title = this.getItemName(selectedLesson);
    }
    return title;
  };

  getTitleType = () => {
    const { selectedUnit, selectedLesson } = this.props;
    let type = I18n.t('gradebook.book');
    if (selectedUnit) {
      type = I18n.t('gradebook.unit');
    }
    if (selectedLesson) {
      type = I18n.t('gradebook.lesson');
    }
    return type;
  };

  getAssignedTile() {
    const { selectedUnit, selectedLesson, selectedBook, groups } = this.props;
    let assignedGroup;
    if (selectedLesson && selectedLesson.configuration) {
      assignedGroup = selectedLesson.configuration;
    } else if (selectedUnit && selectedUnit.configuration) {
      assignedGroup = selectedUnit.configuration;
    } else if (selectedBook && selectedBook.configuration) {
      assignedGroup = selectedBook.configuration;
    }

    if (assignedGroup.groups.length === 0) {
      return <div className={`group-assigned`}>{I18n.t('groups.everyone')}</div>;
    }

    return <GroupAssignedTile assignedGroup={assignedGroup} groups={groups} role={ROLE.INSTRUCTOR} />;
  }

  getTitleIcon() {
    const { selectedUnit, selectedLesson } = this.props;
    let type = 'reading-open-book';
    if (selectedUnit) {
      type = 'directory';
    }
    if (selectedLesson) {
      type = 'blank-paper-sheet';
    }
    return type;
  }

  render() {
    return (
      <div className="gradebook-topbar">
        {this.renderPercentCircle()}
        <div className="gradebook-title">
          <CustomIcon color="#ccc" name={this.getTitleIcon()} size={28} />
          {this.getTitleType()}:<span> {this.getTitle()}</span>
          {this.getAssignedTile()}
        </div>
        <Media query={MOBILE_MEDIA_QUERY}>{isMobile => isMobile && <GradebookHelpButton />}</Media>
      </div>
    );
  }
}

export default GradebookTopBar;
